@if (!hide) {
  <div class="container-left-right main-container">
    <div class="pagination-wrapper">
      <ul class="pagination">
        @for (i of pagesSize; track i; let j = $index) {
          <li
            class="pagination-item"
            [ngClass]="{ 'mod-active': i === pageSize }"
            >
            <a class="pagination-link" (click)="setPageSize(i)" (keydown.enter)="setPageSize(i)" [tabIndex]="0">
              {{ i }}
            </a>
          </li>
        }
      </ul>
    </div>
    <div class="pagination-wrapper">
      @if (last > 1) {
        <ul class="pagination mod-page-jump mr-10">
          <li class="pagination-item mod-first-page" [ngClass]="{ 'mod-disabled': pageNumber === 1 }">
            <a class="pagination-link" (click)="loadFirstPage()" (keydown.enter)="loadFirstPage()" [tabIndex]="0">
              {{ "first" | translate }}
            </a>
          </li>
        </ul>
      }
      @if (last > 1) {
        <ul class="pagination">
          <li class="pagination-item" [ngClass]="{ 'mod-disabled': pageNumber === 1 }">
            <a class="pagination-link" (click)="loadPrev()" (keydown.enter)="loadPrev()" [tabIndex]="0">
              <span class="bpi__icon-caret-left"></span>
            </a>
          </li>
          @for (i of pagesCount; track i; let ind = $index) {
            <li
              class="pagination-item"
              [ngClass]="{ 'mod-active': i === pageNumber }">
              <a class="pagination-link" (click)="loadPage(i)" (keydown.enter)="loadPage(i)" [tabIndex]="0">
                {{ i }}
              </a>
            </li>
          }
          <li class="pagination-item" [ngClass]="{ 'mod-disabled': pageNumber === last }">
            <a class="pagination-link" (click)="loadNext()" (keydown.enter)="loadNext()" [tabIndex]="0">
              <span class="bpi__icon-caret-right"></span>
            </a>
          </li>
        </ul>
      }
      @if (last > 1) {
        <ul class="pagination mod-page-jump ml-10">
          <li class="pagination-item mod-last-page" [ngClass]="{ 'mod-disabled': pageNumber === last }">
            <a class="pagination-link" (click)="loadLastPage()" (keydown.enter)="loadLastPage()" [tabIndex]="0">
              {{ "last" | translate }}
            </a>
          </li>
        </ul>
      }
    </div>
  </div>
}
